import React from "react";
import clicksDarkLogo from "~/images/clicks-logo-dark.svg";
import AuthHeader from "../shared/AuthHeader";
const AuthLayout = ({ children }) => {
  return (
    <div className="h-screen">
      <AuthHeader />
      <div className="flex items-center justify-center px-4">{children}</div>
    </div>
  );
};
export default AuthLayout;
